import emailjs from '@emailjs/browser';

// Create React App inlines these at build time, so they must be read as
// literal `process.env.REACT_APP_*` expressions (dynamic lookups are not
// replaced). A missing value ends up as `undefined` in the bundle, which is
// what makes EmailJS throw "The public key is required" at submit time.
const configured = (raw: string | undefined): string => {
  const value = raw?.trim();
  if (!value || value.startsWith('your_')) return '';
  return value;
};

export const EMAILJS_SERVICE_ID = configured(process.env.REACT_APP_SERVICE_ID);
export const EMAILJS_TEMPLATE_ID = configured(process.env.REACT_APP_TEMPLATE_ID);
export const EMAILJS_PUBLIC_KEY = configured(process.env.REACT_APP_PUBLIC_KEY);

export const isEmailConfigured = Boolean(
  EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID && EMAILJS_PUBLIC_KEY
);

const SETUP_HINT =
  'EmailJS is not configured. Add REACT_APP_SERVICE_ID, REACT_APP_TEMPLATE_ID and ' +
  'REACT_APP_PUBLIC_KEY to .env (see .env.example), then restart or rebuild.';

export class EmailNotConfiguredError extends Error {
  constructor() {
    super(SETUP_HINT);
    this.name = 'EmailNotConfiguredError';
  }
}

export function sendEmail(templateParams: Record<string, string>) {
  if (!isEmailConfigured) {
    return Promise.reject(new EmailNotConfiguredError());
  }
  return emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    templateParams,
    { publicKey: EMAILJS_PUBLIC_KEY }
  );
}
